import React, { useMemo, useState } from "react";
import {
  Modal,
  Flex,
  // Dropdown,
} from "antd";
import { toast } from "react-toastify";
import { toTitleCase } from "../../../../utils/helpers";
// import { EllipsisOutlined } from "@ant-design/icons";
import "./CustomerRulesDetailsModal.css";
import EditCustomerRulesModal from "./EditCustomerRulesModal";
import { getMlQcRulesSpecific } from "../../../../actions/qc";
import RegularTestsGroupedView from "../RegularTestsGroupedView";

// const menuItems = [
//   { key: "edit", label: "Edit" },
//   { key: "delete", label: "Delete" },
// ];

const CustomerRulesDetailsModal = ({
  open,
  onCancel,
  ruleData: rule,
  // onDelete,
  // refetch,
}) => {
  const [ruleData, setRuleData] = useState(rule);
  const [loading, setLoading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  /**
   * handles selecting option in dropdown menu
   * @param {*} menuOption selected option
   */
  // const onMenuItemClick = (menuOption) => {
  //   if (menuOption.key === "edit") {
  //     setShowEditModal(true);
  //   }
  //   if (menuOption.key === "delete") {
  //     onDelete();
  //   }
  // };

  /**
   * fetch updated rule data
   */
  const getRuleData = async () => {
    const params = { customer_id: ruleData.customer_id };
    setLoading(true);
    const response = await getMlQcRulesSpecific(params);
    setLoading(false);
    if (response.success) {
      setRuleData(response.result?.length ? response.result[0] : rule);
    } else {
      toast.error(response.message || "Something went wrong!");
    }
  };

  const checkTestCategories = useMemo(() => {
    const tests = ruleData.sample_info.regular_tests || [];
    const testCagories = tests.reduce((acc, spec) => {
      if (spec.match_scope === "test_category") {
        acc.push(spec[spec.match_scope]);
      }
      return acc;
    }, []);
    return {
      isAllTestCategoies: testCagories.length === tests.length,
      csv: testCagories.length > 0 ? testCagories.join(", ") : "-",
    };
  }, [ruleData]);

  return (
    <>
      <Modal
        centered
        title="Customer Rule Details"
        width={900}
        open={open}
        onCancel={onCancel}
        rootClassName="CustomerRulesDetailsModal"
        footer={null}
        loading={loading}
      >
        <div className="CustomerRulesDetailsModal__Content">
          <Flex vertical align="stretch" gap={16}>
            <Flex align="center" justify="space-between" gap={8}>
              <h4 className="CustomerRulesDetailsModal__Title">
                <strong>Customer ID: </strong>
                <span>{ruleData.customer_id || "Customer Rule"}</span>
              </h4>
              {/* <div className="CustomerRulesDetailsModal__Status">
                <Dropdown
                  type="primary"
                  menu={{
                    items: menuItems,
                    onClick: onMenuItemClick,
                  }}
                  className="CustomerRulesDetailsModal__ActionDropdown"
                >
                  <EllipsisOutlined className="CustomerRulesDetailsModal__ActionIcon" />
                </Dropdown>
              </div> */}
            </Flex>

            {ruleData.sample_info && (
              <>
                <h4 className="CustomerRulesDetailsModal__Title">
                  <strong>Scope: </strong>
                  <span>{toTitleCase(ruleData.scope) || "-"}</span>
                </h4>

                <h4 className="CustomerRulesDetailsModal__Title">
                  <strong>Sample Info: </strong>
                  <span>{ruleData.sample_info.sample_type || "-"}</span>
                </h4>

                <h4 className="CustomerRulesDetailsModal__Title">
                  <strong>Regular Tests: </strong>
                  {checkTestCategories.isAllTestCategoies && <span>{checkTestCategories.csv}</span>}
                </h4>
                {!checkTestCategories.isAllTestCategoies && <RegularTestsGroupedView regularTests={ruleData.sample_info.regular_tests} />}

                <h4 className="CustomerRulesDetailsModal__Title">
                  <strong>QC Pointers: </strong>
                  <span>{ruleData.sample_info.qc_pointers || "-"}</span>
                </h4>

                <h4 className="CustomerRulesDetailsModal__Title">
                  <strong>Specs: </strong>
                  <span>{ruleData.sample_info.specs || "-"}</span>
                </h4>
              </>
            )}
          </Flex>
        </div>
      </Modal>
      {showEditModal && (
        <EditCustomerRulesModal
          open={showEditModal}
          onCancel={() => setShowEditModal(false)}
          editData={ruleData}
          refetch={getRuleData}
        />
      )}
    </>
  );
};

export default CustomerRulesDetailsModal;
